import { render, staticRenderFns } from "./FormConfigFullRandom.vue?vue&type=template&id=dc56cf16&"
import script from "./FormConfigFullRandom.vue?vue&type=script&lang=js&"
export * from "./FormConfigFullRandom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports